import { ApprovalsTableHeadCell } from './type';

export const headCells: ApprovalsTableHeadCell[] = [
  {
    id: 'id',
    numeric: false,
    sortable: true,
    label: 'Inquiry Number',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'createTime',
    numeric: false,
    sortable: true,
    label: 'Inquiry Date',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'acceptedDate',
    numeric: false,
    sortable: true,
    label: 'Approved Date',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'endDate',
    numeric: false,
    sortable: true,
    label: 'Due Date',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'ministryCategory',
    numeric: false,
    sortable: true,
    label: 'Ministry Category',
    minWidth: 70,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'requestId',
    numeric: false,
    sortable: true,
    label: 'Request ID',
    minWidth:60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'requestStatus',
    numeric: false,
    sortable: true,
    label: 'Request Status',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'requestTime',
    numeric: false,
    sortable: true,
    label: 'Request Date',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
  {
    id: 'shippedTime',
    numeric: false,
    sortable: true,
    label: 'Shipped Date',
    minWidth: 60,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },{
    id: 'organization',
    numeric: false,
    sortable: true,
    label: 'Destination Organization',
    minWidth: 100,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },{
    id: 'firstName',
    numeric: false,
    sortable: true,
    label: 'First Name',
    minWidth: 80,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },{
    id: 'lastName',
    numeric: false,
    sortable: true,
    label: 'Last Name',
    minWidth: 80,
    ml: 1,
    disablePadding: true,
    textAlign: 'center',
  },
];

